export * from './lib/shared-search-input';
